import { useEffect, useState } from "react";
import {
  PlayIcon,
  PauseIcon,
  ChevronDoubleDownIcon,
  ChevronDoubleUpIcon,
  QuestionMarkCircleIcon,
} from "@heroicons/react/solid";
import moment from "moment-timezone";
import EpisodeLinks from "./EpisodeLinks";
import ProgressBar from "./ProgressBar";
import Section from "./Section";

const timeFormat = "h:mm:ss a - dddd, Do MMMM YYYY";
const timeFormatLog = "h:mm:ss a";

export default function Episode({
  sendPostMessage,
  newSeek,
  updateTime,
  streamProgress,
  streamPercent,
  duration,
  episode,
  index,
  track,
  setTrack,
  playing,
  playAudio,
  buffering,
  disableMore,
}) {
  const [links, setLinks] = useState([]);
  const [pl, setPl] = useState(true);
  const [m, setM] = useState(false);
  const url = `https://app.myradio.click/api/public/ondemand/${episode.station.hls_stream}/96/${episode.timestamp}/${episode.duration}/listen.m3u8?unique=react-app`;

  // useEffect(() => {
  //   const l = JSON.parse(episode.links);
  //   console.log("links", l);
  //   setLinks(l);
  // }, [episode]);

  const FloatingButton = () => {
    return track === url ? (
      <div className="absolute left-0 bottom-0 text-white  right-0 p-3 bg-gray-900 bg-opacity-50 flex gap-2 items-center">
        <button
          className=""
          onClick={() => {
            if (track === url) {
              playAudio();
            } else {
              setTrack(url);
            }
            sendPostMessage();
          }}
        >
          {track === url && buffering === true ? (
            <svg
              role="status"
              className="w-12 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          ) : (
            <>
              {track === url && playing === true ? (
                <PauseIcon className="h-12 w-12" />
              ) : (
                <PlayIcon className="h-12 w-12" />
              )}
            </>
          )}
        </button>
        <div className="flex-1 block">
          {track === url && (
            <>
              <div className={"progress-wrapper w-full relative mt-1"}>
                <div
                  className="absolute z-10 top-0 right-0 bottom-0 left-0 cursor-pointer  "
                  id={`e${episode.id}`}
                  onClick={(e) => updateTime(e, `e${episode.id}`)}
                ></div>
                <ProgressBar
                  seek={newSeek}
                  index={index}
                  completed={streamPercent}
                />
              </div>
              <div className="text-white grid grid-cols-2 text-white mt-2">
                <div className="col-span-1">
                  {moment.utc(streamProgress * 1000).format("mm:ss")}
                </div>
                <div className="col-span-1 text-right">{duration}</div>
              </div>
            </>
          )}
        </div>
      </div>
    ) : (
      <div></div>
    );
  };

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-4 xl:col-span-4 block pb-4 mb-2 border-solid border-2 rounded border-gray-200 bg-white">
      {episode.program && episode.program.website_url ? (
        <a
          target="_parent"
          href={episode.program.website_url}
          className="p-3 flex gap-4 items-center "
        >
          {episode.program.image ? (
            <img
              className="rounded-full w-10 h-10"
              src={
                episode.program.image.webp
                  ? episode.program.image.webp.tile
                  : episode.program.image.url
              }
            />
          ) : (
            <QuestionMarkCircleIcon className="h-10 w-10" />
          )}
          <p className="font-bold">{episode.program.name}</p>
        </a>
      ) : (
        <div className="p-3 flex gap-4 items-center">
          {episode.program.image ? (
            <img
              className="rounded-full w-10 h-10"
              src={
                episode.program.image.webp
                  ? episode.program.image.webp.tile
                  : episode.program.image.url
              }
            />
          ) : (
            <QuestionMarkCircleIcon className="h-10 w-10" />
          )}
          <p className="font-bold">{episode.program.name}</p>
        </div>
      )}
      {episode.image || episode.program.image ? (
        <div className="w-full relative aspect-square flex items-center justify-center mb-4 bg-gray-100">
          <img
            src={
              episode.image && episode.image.webp
                ? episode.image.webp.tile
                : episode.program.image && episode.program.image.webp
                ? episode.program.image.webp.tile
                : null
            }
            alt={episode.title}
            className={"w-full  our-image object-contain h-auto aspect-square"}
          />
          <FloatingButton />
        </div>
      ) : episode.program.image ? (
        <div className="w-full relative aspect-square flex items-center justify-center mb-4 bg-gray-100">
          <img
            src={
              episode.program.image.webp
                ? episode.program.image.webp.tile
                : episode.program.image.url
            }
            alt={episode.title}
            className={"w-full h-auto our-image object-contain aspect-square"}
          />
          <FloatingButton />
        </div>
      ) : (
        <div className="w-full relative blank aspect-square bg-gray-200 flex items-center justify-center mb-4 aspect-square">
          <QuestionMarkCircleIcon className="text-gray-400 h-12 w-12" />
          <FloatingButton />
        </div>
      )}
      <div className=" flex gap-4 items-start justify-between px-4">
        <span>
          <p className="text-xl font-bold">
            {episode.title ? episode.title : <>{episode.program.name}</>}
          </p>
          <div className="grid grid-cols-5 gap-4">
            <p className="text-xs uppercase col-span-3 text-gray-600 font-light">
              {moment
                .utc(episode.timestamp * 1000)
                .tz(episode.station.timezone)
                .format("ddd, Do MMM YY, h:mm a")}
            </p>
            {/* <p className="text-sm col-span-2">
              <strong>Duration:</strong>
              <br />
              {moment.utc(episode.duration * 1000).format("mm:ss")}
            </p> */}
          </div>
          {episode.content && <p className="mt-4">{episode.content}</p>}
          {links && links.length > 0 && (
            <EpisodeLinks links={links} episode={episode} index={index} />
          )}
        </span>
        <button
          onClick={() => {
            if (track === url && playing === true) {
              playAudio();
            } else {
              setTrack(url);
            }
            sendPostMessage();
          }}
        >
          {track === url && buffering === true ? (
            <svg
              role="status"
              className="w-12 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          ) : (
            <>
              {track === url && playing === true ? (
                <PauseIcon className="h-12 w-12" />
              ) : (
                <PlayIcon className="h-12 w-12" />
              )}
            </>
          )}
        </button>
      </div>
      {(episode.content ||
        episode.sections.length > 0 ||
        episode.logs.length > 0) && (
        <div>
          {!disableMore && (
            <div className="text-center w-full mt-4">
              {m === true ? (
                <button
                  className="text-sm flex gap-2 w-full item-center justify-center"
                  onClick={() => setM(false)}
                >
                  <ChevronDoubleUpIcon className="h-4 w-4" /> Hide Details
                </button>
              ) : (
                <button
                  className="text-sm flex gap-2 w-full item-center justify-center"
                  onClick={() => {
                    setM(true);
                    sendPostMessage();
                  }}
                >
                  <ChevronDoubleDownIcon className="h-4 w-4" />
                  Show Details
                </button>
              )}
            </div>
          )}
          {m && (
            <div>
              {episode && episode.description && (
                <p
                  itemProp="description"
                  className="mb-2 mt-3 mb-3 px-4 text-sm"
                  dangerouslySetInnerHTML={{
                    __html: episode.description
                      ? episode.description.split("\n").join("<br>")
                      : "",
                  }}
                ></p>
              )}
              {episode.sections && episode.sections.length > 0 && (
                <div className="section mt-4">
                  <h5 className=" px-4 text-sm font-bold">
                    Featured Sections:
                  </h5>
                  {episode.sections.length > 0 && (
                    <div className="grid grid-cols-12 gap-4 p-2">
                      {episode.sections.map((section, i) => (
                        <Section
                          updateTime={updateTime}
                          newSeek={newSeek}
                          buffering={buffering}
                          section={section}
                          setTrack={setTrack}
                          playing={playing}
                          track={track}
                          index={i}
                          key={i}
                          playAudio={playAudio}
                          streamProgress={streamProgress}
                          streamPercent={streamPercent}
                          duration={duration}
                          config={{
                            file: {
                              forceAudio: true,
                            },
                          }}
                        />
                      ))}
                    </div>
                  )}
                </div>
              )}
              {episode.logs.length > 0 && (
                <>
                  {/* <div className="text-center w-full mt-4">
                    {pl === true ? (
                      <button
                        className="text-sm flex gap-2 w-full item-center justify-center"
                        onClick={() => setPl(false)}
                      >
                        <ChevronDoubleUpIcon className="h-4 w-4" /> Hide
                        Playlist
                      </button>
                    ) : (
                      <button
                        className="text-sm flex gap-2 w-full item-center justify-center"
                        onClick={() => setPl(true)}
                      >
                        <ChevronDoubleDownIcon className="h-4 w-4" />
                        Show Playlist
                      </button>
                    )}
                  </div> */}

                  {episode && pl === true && episode.logs.length > 0 && (
                    <section>
                      {episode &&
                        episode.logs.map((log, i) => (
                          <div
                            key={`log${i}`}
                            className="px-4 border-solid logs mb-2"
                          >
                            {episode.hide_times !== 1 && (
                              <p className="text-xs">
                                {moment(log.local).format(timeFormatLog)}{" "}
                              </p>
                            )}
                            <p className="text-base">
                              <span className="font-bold">{log.title}</span>{" "}
                              {log.artist && (
                                <span className="">by {log.artist}</span>
                              )}{" "}
                              <span className=" text-xs">
                                {log.location && log.location === "nat"
                                  ? "(nat)"
                                  : log.location && log.location === "int"
                                  ? "(int)"
                                  : "(loc)"}
                              </span>
                            </p>
                            {log.album && (
                              <p className="text-xs">Release: {log.album}</p>
                            )}
                          </div>
                        ))}
                    </section>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
